//
// Collection names
//
export const JOB_POSTINGS_COLLECTION = 'jobPostings';
